(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('MaquinasCtrl', MaquinasController);

  MaquinasController.$inject = [
    '$scope',
    '$routeParams',
    'LoadingService',
    'MaquinasService',
    '$location',
    'Flash',
    '$route',
    'MessagesService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function MaquinasController($scope, $routeParams, LoadingService,
    MaquinasService, $location, Flash, $route, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.createNew = false;
    vm.pages = {
      numbers: [],
      pagination: {}
    };
    vm.showSearch = true;
    vm.loading = true;
    vm.maquinas = [];
    vm.search = {
      descricao: null,
      grupo: null
    };
    vm.permissions = {};

    //////////////////////////////////////////
    // Bindable functions
    vm.setPage = setPage;
    vm.openEdit = openEdit;
    vm.searchMaquinas = searchMaquinas;
    vm.clearFilters = clearFilters;
    vm.isFiltering = isFiltering;
    vm.paginationVisible = paginationVisible;

    //////////////////////////////////////////
    // Function declarations

    function setPage(page) {
      $route.updateParams({ page });
    }

    function loadMaquinas() {
      vm.loading = true;
      vm.search = {
        descricao: $routeParams.descricao || '',
        grupo: ($routeParams.grupo && _.find(vm.groups, { id: +$routeParams.grupo })) || null
      };
      vm.maquinas = [];
      vm.createNew = false;

      return MaquinasService.listPaginated({
        descricao: vm.search.descricao,
        grupo: (vm.search.grupo || {}).id,
        page: $routeParams.page
      })
        .then((result) => {
          vm.maquinas = result.data;
          vm.pages = result.pages;
        })
        .catch((error) => {
          console.error('Erro ao carregar máquinas', error);
          MessagesService.alert('Erro ao carregar máquinas, tente novamente.');
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function loadExtraData() {
      return MaquinasService.listGroups()
        .then((result) => {
          vm.groups = result.data;
        })
        .catch((error) => {
          console.error('Erro carregando dados', error);
          MessagesService.alert('Erro carregando dados, tente novamente.');
        });
    }

    function openEdit(index) {
      vm.maquinas.forEach((maquina, i) => {
        if (i === index) {
          vm.createNew = false;
          maquina.edit = true;
        } else {
          maquina.edit = false;
        }
      });
    }

    function searchMaquinas() {
      $route.updateParams({
        descricao: vm.search.descricao,
        grupo: (vm.search.grupo || {}).id,
        page: null
      });
    }

    function clearFilters() {
      $route.updateParams({
        descricao: null,
        grupo: null,
        page: null
      });
    }

    function isFiltering() {
      return !!$routeParams.descricao || !!$routeParams.grupo;
    }

    function paginationVisible() {
      return vm.maquinas.length && vm.pages.numbers.length && !vm.loading;
    }

    //////////////////////////////////////////
    // Controller logic
    const permissions = function() {
      vm.permissions = angular.copy($scope.$root.permissions.maquina);
      if ($scope.$root.parametros.enable_sync_to_postgres && !$scope.$root.parametros.nao_cliente_agrogestao) {
        vm.permissions.canManage = false;
      }
    };

    LoadingService.showLoading();
    $scope.$root.initialize
      .then(() => {
        permissions();
        if (!vm.permissions.canRead) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          // eslint-disable-next-line no-useless-return
          return;
        }
      }).then(() => {
        LoadingService.hideLoading();
        return loadExtraData();
      })
      .then(() => loadMaquinas())
      .catch(() => $scope.$root.errorRootInitialize());

    // Eventos do editor
    $scope.$on('cancelCreate', () => vm.createNew = false);
    $scope.$on('cancelEdit', (_event, maquina) => maquina.edit = false);
    $scope.$on('maquinaUpdated', (_event, maquina, result) => {
      vm.maquinas[vm.maquinas.indexOf(maquina)] = result;
    });
    $scope.$on('maquinaCreated', () => loadMaquinas());

    // Eventos da rota
    $scope.$on('$routeUpdate', () => loadMaquinas());
  }
}());
